import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-part-correct-mark",
  "use": "foquz-icon-part-correct-mark-usage",
  "viewBox": "0 0 10 13",
  "content": "<symbol viewBox=\"0 0 10 13\" fill=\"none\" id=\"foquz-icon-part-correct-mark\"><path d=\"M1 5h8m-8 7h8M5 9V1\" stroke=\"#F4A224\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol